import React, { useEffect } from 'react'
import Img from 'gatsby-image'
import { useDispatch } from 'react-redux'
import cn from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import _ from 'lodash'
import { Button } from '@gymondo/frontend-core/components'
import { mediaXsOnly } from '@gymondo/frontend-core/style-vars'
import { useMediaQuery } from '@gymondo/frontend-core/hooks'
import { useGraphqlDataHook } from './use-graphql-data.hook'
import style from './community.module.scss'
import { config } from './config/community.config'
import { generateTrackingAttributes } from './util/tracking.util'
import { setConfig } from '../../../service/layout'
import { BackgroundImage, PageHero, ContentGrid } from '../../../component'

const renderInstagramBottomSection = (instagramImages, intl) => (
    <div className={cn('row top-xs', style.instagramImages)}>
        <div className="col-xs-6 col-sm-4 col-sm-offset-2">
            <a
                href={intl.formatMessage({
                    id: 'community.link.instagram',
                })}
                target="_blank"
                rel="noopener noreferrer"
                {...generateTrackingAttributes({
                    label: 'instagram',
                    value: 'image-cta',
                })}
            >
                <Img fluid={instagramImages[2]} />
            </a>
        </div>
        <div className="col-xs-6 col-sm-5">
            <a
                href={intl.formatMessage({
                    id: 'community.link.instagram',
                })}
                target="_blank"
                rel="noopener noreferrer"
                {...generateTrackingAttributes({
                    label: 'instagram',
                    value: 'image-cta',
                })}
            >
                <Img fluid={instagramImages[1]} />
            </a>
        </div>
    </div>
)

const getCta = (id) => (
    <Button flex={false} size="medium">
        <FormattedMessage id={id} />
    </Button>
)

const getFacebookVisuals = (isXs, fbImage) => (
    <div className={cn(style.imageLinkWrapper, style.heroImageWrapper)}>
        {isXs ? (
            <Img fluid={fbImage} />
        ) : (
            <BackgroundImage
                fluid={fbImage}
                classParentName="image__background--center-position"
            />
        )}
    </div>
)

const getInstagramVisuals = (image) => (
    <div className={style.imageLinkWrapper}>
        <Img fluid={image} />
    </div>
)

export const Community = () => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const data = useGraphqlDataHook()
    useEffect(() => {
        dispatch(setConfig({ textColorVariant: 'white', logoVariant: 'white' }))
    }, [dispatch])
    const isXs = useMediaQuery(mediaXsOnly)

    const fbImage = _.get(data, 'facebook.edges.0.node.childImageSharp.fluid')
    const instagramImages = _.get(data, 'instagram.edges').map((edge) =>
        _.get(edge, 'node.childImageSharp.fluid')
    )

    const lang = intl.locale.split('-')[0]

    const localizedInstagramImages = data?.instagramLocalized?.edges?.filter(
        (edge) => edge.node.childImageSharp.fluid.originalName.includes(lang)
    )

    instagramImages.push(
        localizedInstagramImages[0]?.node.childImageSharp.fluid
    )

    const { hero, facebook, instagram } = config

    return (
        <div className={style.page}>
            <PageHero
                title={hero.title}
                subtitle={hero.subtitle}
                className={style.heroWrapper}
            />
            <div className={cn('wrapper', style.wrapper)}>
                <ContentGrid
                    config={facebook}
                    descriptionChildren={getCta(facebook.cta)}
                    visualChildren={getFacebookVisuals(isXs, fbImage)}
                />
                <ContentGrid
                    config={instagram}
                    descriptionChildren={getCta(instagram.cta)}
                    visualChildren={getInstagramVisuals(instagramImages[0])}
                />
                {renderInstagramBottomSection(instagramImages, intl, isXs)}
            </div>
        </div>
    )
}

export default Community
